<template>
  <component
    class="icon-with-action"
    :is="href ? ($router && !isExternalUrl ? 'router-link': 'a') : 'button'"
    :to="href || false"
    :href="href || false"
    :type="componentTag === 'button' && componentTag"
    :disabled="disabled"
    :class="{disabled, 'hover-effect': hoverEffect, 'remove-action': removeAction}"
    @click="$emit('click', $event)"
  >
    <slot/>
  </component>
</template>
<script>
export default {
  name: 'AppIconWithAction',
  props: {
    href: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hoverEffect: {
      type: Boolean,
      default: true
    },
    removeAction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isExternalUrl () {
      return this.href.startsWith('https://')
    },
    componentTag () {
      return this.href ? (this.$router && !this.isExternalUrl ? 'router-link' : 'a') : 'button'
    }
  }
}
</script>
<style scoped lang="scss">
.icon-with-action {
  &.disabled {
    cursor: default;

    i {
      color: $gray-300;
    }

    &:hover, &:active, &:focus {
      i {
        color: $gray-300;
      }
    }
  }

  transition: all ease 0.5s;
  cursor: pointer;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  outline: none;
  background: transparent;
  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;
  /* Normalize `line-height`. Cannot be changed from `normal` in Firefox 4+. */
  line-height: normal;
  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  /* Corrects inability to style clickable `input` types in iOS */
  -webkit-appearance: none;
  /* Remove excess padding and border in Firefox 4+ */
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  &.disabled {
    i {
      color: $gray-400 !important;
    }
  }

  &.hover-effect {
    &:not(.disabled) {
      &:hover, &:active, &:focus {
        border: none;
        outline: none;

        i {
          color: $primary-darken !important;
        }
      }
      &.remove-action {
        &:hover, &:active, &:focus {
          i {
            color: $danger !important;
          }
        }
      }
    }
  }

}
</style>
